import React,{useState,useEffect} from 'react'
import BasicDetailsForm from './BasicDetailsForm'
import BrideGroomForm from './BrideGroomForm';
import ExtraDetails from './ExtraDetails';
import Navbar from '../../helpers/Navbar';
import { useSelector,useDispatch } from 'react-redux';
import {snackbarContext} from '../../helpers/Snakbar'
import { useNavigate } from 'react-router-dom';
import { clearUser } from '../../../redux/reducers/authSlice';
import { clearError } from '../../../redux/reducers/profileSlice';
import {TabTitle} from '../../helpers/GeneralFunctions'
import Footer from '../../helpers/Footer';
import PreviewButton from '../../helpers/PreviewButton';
import Stepper from './Stepper';
import CountdownDetail from './CountdownDetail';
import EnvelopeForm from './EnvelopeForm';
import Progress from './Progress';
const FormContainer = () => {
  TabTitle("Wedding Details")
  const dispatch=useDispatch()
  const navigate=useNavigate()
  const setStateSnackbarContext=React.useContext(snackbarContext)
  const {error:backendError,weddingData: data,profileLoaded} = useSelector((state) => state.profile)
   const {user} = useSelector(state => state.auth);
const now = new Date().getTime();
const expiryTime = new Date(user && user.demoExpiryTime).getTime();
const isDemoExpired = user && user.demoVersion && expiryTime && now > expiryTime;
const isInviteExpired= user && user.inviteTimeExpired


  const [currentStep, setCurrentStep] = useState(1);
  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  useEffect(()=>{
    if (backendError === "session expired" || backendError==="pls login to acess the resource") {
        setStateSnackbarContext(true, "session expired please login again", "error");
        dispatch(clearError())
        dispatch(clearUser())
        navigate("/login")
    }else if (backendError) {
        setStateSnackbarContext(true, backendError, "error");
        dispatch(clearError());
      }
},[backendError])




if(user && user.hasEnded){
navigate("/display/notfound")
}

if(user && user.needsDate===true){
  navigate("/")
}

if(isDemoExpired){
  navigate("/")
}

if(isInviteExpired){
  navigate("/")
}

useEffect(() => {
    if (!profileLoaded) return;

    if (!data?.theme) {
        setStateSnackbarContext(
            true,
            "Please select Theme",
            "warning"
        );

        navigate("/sample-themes");
    }
}, [profileLoaded, data?.theme, navigate]);



  return (
    <>
    <Navbar/>
    <Stepper step={1} demoVersion={user && user.demoVersion}/>
       <Progress
      activeStep={currentStep - 1}
      demoVersion={user && user.demoVersion}
      onPrevious={handleBack}
      onNext={handleNext}
    />
  {/* <PreviewButton onClick={() => navigate(`/private/preview/${user && user.userCode}`)}/> */}
      {currentStep === 1 &&
        <BasicDetailsForm  
        // weddingData={weddingData} 
        // setWeddingData={setWeddingData}
        onNext={handleNext}
         />
      }

      {currentStep===2 &&  
      <CountdownDetail   onBack={handleBack}  onNext={handleNext}  />
   
      }

      {currentStep===3 &&  
       <BrideGroomForm  onBack={handleBack}  onNext={handleNext} />
      }

      {currentStep===4 &&
      <EnvelopeForm  onBack={handleBack}  onNext={handleNext} />
      }

      {currentStep===5 && 
      <ExtraDetails onBack={handleBack}/>
      }
      <Footer userCode={user&&user.userCode}/>
    </>
  
  )
}

export default FormContainer